import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';

import QueryKeys from '../queryKeys';
import useGetMyInfoQuery from '../user/useMyInfoQuery';

const url = '/api/user/bookmark/detail';

interface Params {
  onError?: (e: unknown) => void;
}

export interface IBookmark {
  PK_NM_HASH: string;
  location: string;
  name: string;
  companyId: number;
}

export default function useBookmark(params?: Params) {
  const { isActiveUser } = useGetMyInfoQuery();

  return useQuery<IBookmark[]>([QueryKeys.bookmark, 'detail'], () => fetcher(url), {
    enabled: isActiveUser,
    onError: params?.onError,
  });
}
